import { localStorage } from '@ben/orion/utils/storage';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'table-page-size';
const DEFAULT_PAGE_SIZE = 10;

export const getStoredPageSize = () =>
  Number(localStorage.get(STORAGE_KEY)) || DEFAULT_PAGE_SIZE;

export const setStoredPageSize = (pageSize: number) =>
  localStorage.set(STORAGE_KEY, String(pageSize));

export const usePageSizeState = (): [number, (pageSize: number) => void] => {
  const [pageSize, setPageSize] = useState(getStoredPageSize());

  useEffect(() => {
    setStoredPageSize(pageSize);
  }, [pageSize]);

  return [pageSize, setPageSize];
};
